// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/query-event-by-pk.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_TreatmentAutomations($id: uuid!) {
  events_events_by_pk(id: $id) {
    id
    name
    data
    type
    status
    updated_at
    automation_type
    trigger_type
    organization_id
    app {
      id
      name
    }
    actions(order_by: [{ order: asc }]) {
      id
      type
      name
      order
      data
      action_executions(limit: 1) {
        id
      }
    }
  }
}

`